import React, { useMemo, useState } from "react";
import {
  Title,
  Select,
  GoBack,
  Button,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import ExteriorImages from "./exteriorImages";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

// --- Helpers ---
const slugify = (str) =>
  (str || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  // --- Form state ---
  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [title, setTitle] = useState("");
  const [venue, setVenue] = useState("");
  const [rating, setRating] = useState("");

  const [fee, setFee] = useState(0);
  const [vip, setVip] = useState(0);
  const [vvip, setVvip] = useState(0);

  const [email, setEmail] = useState("");
  const [payLink, setPayLink] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");

  const [hashtags, setHashtags] = useState("");
  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState("");

  const [featured, setFeatured] = useState("no");
  const [promoted, setPromoted] = useState("no");
  const [hotelStatus, setHotelStatus] = useState(1);

  const [description, setDescription] = useState("");
  const [collection, setCollection] = useState([]);
  const [exteriorImages, setExteriorImages] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showExtImages, setShowExtImages] = useState(false);
  const [expo, setExpo] = useState(0);
  const [showTop, setShowTop] = useState(0);
  const [pricing, setPricing] = useState([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);

  const hotelRoutes = "/data/hotel";

  const clearAlerts = () => {
    setError(false);
    setSuccess(false);
    setErrorMessage("");
  };

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(defaultImage);
    setThumbnailId("img_cdn_id");

    setTitle("");
    setVenue("");
    setRating("");

    setFee(0);
    setVip(0);
    setVvip(0);

    setEmail("");
    setPayLink(null);
    setPhoneNumber("");
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");

    setHashtags("");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress("");

    setFeatured("no");
    setPromoted("no");
    setHotelStatus(1);

    setDescription("");
    setCollection([]);
    setExteriorImages([]);
    setShowTop(0);
    setExpo(0);
    setPricing([]);
  };

  const responses = (isError, msg) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg || "");
  };

  const isValid = useMemo(() => {
    return Boolean(country_id && title?.trim() && thumbnail && thumbnailId);
  }, [country_id, title, thumbnail, thumbnailId]);

  const addOneHotelHandler = async (e) => {
    e.preventDefault();
    clearAlerts();
    setLoading(true);

    if (!isValid) {
      responses(
        true,
        !country_id
          ? "Select a country/position first"
          : "Image and Title are required"
      );
      return;
    }

    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? slugify(title) : null,
      description: description,
      venue: venue,
      rating: rating,
      fee: fee,
      vip: vip,
      vvip: vvip,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags || ""}${tags ? ", " : ""}${hashtags || ""}`,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: hotelStatus,
      featured: featured,
      promoted: promoted,
      subdata: collection?.length > 0 ? collection : [],
      expo: expo,
      show_top: showTop,
      exterior_images: exteriorImages?.filter((x) => x?.thumbnail !== null),
      pricing: pricing,
    };

    const { status, message } = await createOneContent({
      data,
      content: _TYPES_.HOTEL,
    });

    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  return (
    <div className="p-4 lg:p-6 h-full overflow-y-auto bg-gray-50">
      <BreadCrumbComponent />
      <div className="flex items-center justify-between mt-2">
        <GoBack props={{ route: hotelRoutes }} />
        <div className="text-xs text-gray-500">{country_name || ""}</div>
      </div>

      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={setDescription}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}

      <div className="my-4">
        <DashboardIntro props={{ intro: `Add Hotel`, name: entry_label }} />
      </div>

      {/* Alerts */}
      <div className="max-w-6xl mx-auto">
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={clearAlerts}
          onClick={clearAlerts}
        />
      </div>

      {/* Form */}
      <form
        onSubmit={addOneHotelHandler}
        className="max-w-6xl mx-auto space-y-6"
      >
        {/* Media */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Cover Image" }} />
          <p className="text-xs text-gray-500 mb-3">
            Upload a high-quality thumbnail. JPG/PNG recommended.
          </p>
          <ImageKitUpload
            thumbnail={thumbnail}
            thumbnailId={thumbnailId}
            setThumbnail={setThumbnail}
            setThumbnailId={setThumbnailId}
            folder={image_kit_folder(country_name, FOLDERS.HOTELS)}
          />
        </section>

        {/* Hotel Details */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Hotel Details" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <InputField
              props={{
                id: "title",
                title: "Title",
                type: "text",
                required: true,
                value: title,
                placeholder: "e.g., LakeView Resort & Spa",
                onChange: (e) => setTitle(e.target.value),
              }}
            />
            <Select
              props={{
                id: "top",
                title: "Show In Top Hotels",
                option: ["no", "yes"],
                onChange: (e) => setShowTop(e.target.value === "yes" ? 1 : 0),
              }}
            />
            <InputField
              props={{
                id: "venue",
                title: "Venue",
                type: "text",
                value: venue,
                placeholder: "Neighborhood / Area",
                onChange: (e) => setVenue(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "formatted_address",
                title: "Formatted Address",
                type: "text",
                value: formattedAddress,
                placeholder: "Street, City, Region",
                onChange: (e) => setFormattedAddress(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "rating",
                title: "Rating",
                type: "number",
                value: String(rating || ""),
                placeholder: "e.g., 4.5",
                onChange: (e) => setRating(e.target.value),
              }}
            />
          </div>
          <div className="mt-2 text-xs text-gray-500">
            Slug preview:{" "}
            <span className="font-mono">{slugify(title) || "(auto)"}</span>
          </div>
        </section>

        {/* Pricing */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Pricing" }} />
          <Pricing pricing={pricing} setPricing={setPricing} />
        </section>

        {/* Contact Info */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Contact Info" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <div className="flex items-center">
              <PhoneInput
                setPhone={setPhoneNumber}
                phone={phoneNumber}
                required={false}
              />
            </div>
            <InputField
              props={{
                id: "email",
                title: "Email Address",
                type: "email",
                value: email,
                placeholder: "info@hotel.com",
                onChange: (e) => setEmail(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "pay-link",
                title: "Pay Link (Optional)",
                type: "text",
                value: payLink ? payLink : null,
                onChange: (e) => {
                  setPayLink(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </section>

        {/* Social Contact */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Social Contact" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <InputField
              props={{
                id: "whatsapp",
                title: "Whatsapp",
                type: "text",
                value: whatsapp,
                onChange: (e) => setWhatsapp(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "facebook",
                title: "Facebook",
                type: "text",
                value: facebook,
                onChange: (e) => setFacebook(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "twitter",
                title: "Twitter",
                type: "text",
                value: twitter,
                onChange: (e) => setTwitter(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "instagram",
                title: "Instagram",
                type: "text",
                value: instagram,
                onChange: (e) => setInstagram(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "youtube",
                title: "YouTube",
                type: "text",
                value: youtube,
                onChange: (e) => setYoutube(e.target.value),
              }}
            />
          </div>
        </section>

        {/* Geo Position */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Geo Position" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
            <InputField
              props={{
                id: "google_map_code",
                title: "Google Map Code",
                type: "text",
                value: googleMapCode,
                onChange: (e) => setGoogleMapCode(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "latitude",
                title: "Latitude",
                type: "text",
                value: latitude,
                onChange: (e) => setLatitude(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "longitude",
                title: "Longitude",
                type: "text",
                value: longitude,
                onChange: (e) => setLongitude(e.target.value),
              }}
            />
          </div>
        </section>

        {/* More Settings */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "More Settings" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <Select
              props={{
                id: "hotel_status",
                title: "Status",
                option: ["visible", "invisible"],
                onChange: (e) =>
                  setHotelStatus(e.target.value === "visible" ? 1 : 0),
              }}
            />
            <Select
              props={{
                id: "featured",
                title: "Featured",
                option: ["no", "yes"],
                onChange: (e) => setFeatured(e.target.value),
              }}
            />
            <Select
              props={{
                id: "promoted",
                title: "Promoted",
                option: ["no", "yes"],
                onChange: (e) => setPromoted(e.target.value),
              }}
            />
            <Select
              props={{
                id: "gallery",
                title: "Show in Gallery",
                option: ["no", "yes"],
                onChange: (e) => setExpo(e.target.value === "yes" ? 1 : 0),
              }}
            />
          </div>
        </section>

        {/* Description & Tags */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <div className="flex items-center justify-between">
            <Title props={{ title: "Description" }} />
            <MyButton
              onClick={() => setShowDescriptionModal(true)}
              className="bg-blue-700 py-2 px-4 rounded-lg text-white"
            >
              Generate Description
            </MyButton>
          </div>
          <TextArea
            props={{
              id: "description",
              title: "Description",
              type: "text",
              value: description,
              onChange: (e) => setDescription(e.target.value),
            }}
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full pt-4">
            <InputField
              props={{
                id: "hashtag",
                title: "Tags (comma separated)",
                type: "text",
                value: hashtags,
                onChange: (e) => setHashtags(e.target.value),
              }}
            />
          </div>
        </section>

        {/* Galleries & Extras */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Galleries & Extras" }} />
          <div className="w-full flex flex-wrap gap-3 items-center pt-2">
            <Button
              props={{
                type: "button",
                title: "Add Inter. / Exter. Images",
                category: "default",
                action: "add",
                onClick: () => setShowExtImages(true),
              }}
            />
            <Button
              props={{
                type: "button",
                title: "Add More Details",
                category: "default",
                action: "add",
                onClick: () => setShowModal(true),
              }}
            />
          </div>
        </section>

        {/* Footer Actions */}
        <div className="sticky bottom-0 z-10 bg-gray-50/90 backdrop-blur border-t border-gray-200 py-3">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-xs text-gray-500">
              {isValid ? "Ready to submit" : "Provide a title and cover image"}
            </div>
            <div>
              <MyActionButton
                loading={loading}
                title="Add Hotel"
                onClick={clearAlerts}
              />
            </div>
          </div>
        </div>
      </form>

      {/* Modals */}
      <ModalDetails
        onClick={() => setShowModal(false)}
        showModal={showModal}
        collection={collection}
        setCollection={setCollection}
      />
      <ExteriorImages
        exteriorImages={exteriorImages}
        setExteriorImages={setExteriorImages}
        showModal={showExtImages}
        onClick={() => setShowExtImages(false)}
      />
    </div>
  );
};

export default Add;
